import React, { useState, useEffect } from "react";
import CustomerReservationTable from "../../../customerReservation/CustomerReservationTable";
import styles from "./OrdersSearch.module.scss";
import SubNav from "../../../../shared/subnav/SubNav";
import { LANGUAGE_MARKET_MAP } from "../../../../common/Constants";
import { AVAILABLE_MARKETS } from "./AvailableMarkets";
import CustomerReservationsClient from "../../../../shared/clients/CustomerReservationsClient";
import LocalizedInfoClient from "../../../../shared/clients/LocalizedInfoClient";
import OrderDetailsNewVersion from "../../../customerOrderDetail/orderDetailsNewVersion/OrderDetailsNewVersion";
import { is400 } from "../../../../errors/ErrorConstants";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import { withTranslation } from "react-i18next";
import AuthenticationClient from "../../../../shared/clients/AuthenticationClient";

function OrdersSearch(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [reservations, setReservations] = useState({});
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [commonId, setCommonId] = useState("");
  const [orderId, setOrderId] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [selectedMarket, setSelectedMarket] = useState(undefined);
  const [localizedInfo, setLocalizedInfo] = useState({});
  const [renderApp, setRenderApp] = useState(false);
  const [listOfMarkets, setListOfMarkets] = useState([]);

  const showCountryDropDown = props.user.permissions.rolePermissions.hasOwnProperty(
    "imgCountryDropDown:view"
  );

  useEffect(() => {
    setSelectedMarket(props.user.market);
    setListOfMarkets(props.groups);
    const defaultUserMarket = props.user.market.toUpperCase();
    setSelectedMarket(defaultUserMarket);
    fetchLocalizedInfo(defaultUserMarket);

    return () => {
      props.user.removeReadOnlyPermissions();
    };
  }, []);

  function onMarketChange(event) {
    event.preventDefault();
    const market = event.target.value;
    setSelectedMarket(market);
    setListOfMarkets(props.groups);
  }

  function handleShowOrderDetails(commonId, orderId, showDetails) {
    if (showDetails) {
      AuthenticationClient.getReadOnlyPermissions(
        props.user,
        selectedMarket
      ).then((res) => {
        props.user.addReadOnlyPermissions(res);
        setShowOrderDetails(showDetails);
        setCommonId(commonId);
        setOrderId(orderId);
      });
    } else {
      props.user.removeReadOnlyPermissions();
      setShowOrderDetails(showDetails);
      setCommonId(commonId);
      setOrderId(orderId);
    }
  }

  function searchOrders(e) {
    props.hideOrShow(true);
    e.preventDefault();
    CustomerReservationsClient.searchCustomerReservations(
      searchQuery.trim(),
      props.user,
      LANGUAGE_MARKET_MAP[selectedMarket.toUpperCase()],
      null,
      selectedMarket
    )
      .then((response) => {
        parseReservations(response);
      })
      .catch((error) => {
        if (is400(error)) {
          setReservations({});
        }
        setLoaded(true);
        setReservations({});
        props.hideOrShow(false);
      });
  }

  function parseReservations(reservations) {
    const tempReservations = {};
    reservations.forEach((reservation) => {
      if (reservation.dealerId in tempReservations) {
        tempReservations[reservation.dealerId].push(reservation);
      } else {
        tempReservations[reservation.dealerId] = [];
        tempReservations[reservation.dealerId].push(reservation);
      }
    });

    setReservations(tempReservations);
    setLoaded(true);
    props.hideOrShow(false);
  }

  function updateSearchQuery(event) {
    setSearchQuery(event.target.value);
  }

  function changeMarket(e) {
    setSelectedMarket(e.target.value);
    setReservations({});
    setSearchQuery("");
    setLoaded(false);
    fetchLocalizedInfo(e.target.value);
  }

  function fetchLocalizedInfo(marketID) {
    LocalizedInfoClient.getLocalizedInfo(props.user, marketID)
      .then((result) => {
        setLocalizedInfo(result);
      })
      .finally(() => {
        setRenderApp(true);
      });
  }

  return renderApp ? (
    !showOrderDetails ? (
      <div>
        <section className="pageWrapper">
          {props.user.permissions.rolePermissions.hasOwnProperty(
            "searchLandingPage"
          ) && (
            <BackToButton
              backToUrl={props.isCrc ? "/" : "/search"}
              display={props.t("SearchWrapper.backToSearch")}
            />
          )}
          <SubNav
            dashboard={false}
            showCustomDropdown={showCountryDropDown}
            showCustomMarketDropdown={props.showMarketDropDown}
            selectedMarket={selectedMarket}
            listOfMarkets={listOfMarkets}
            updateMarket={onMarketChange}
            value={selectedMarket}
            dropDownValues={AVAILABLE_MARKETS}
            onChange={changeMarket}
            title="RESERVATIONS"
            {...props}
          />
          <div className={styles.bottomPadding}>
            <div className={styles.indent}>
              <p className={styles.subheader}>
                To search for a consumer order, enter a valid customer email
                address or Reservation ID number.
              </p>
              <div className={styles.searchWrapper}>
                SEARCH BY:
                <form className={styles.form} onSubmit={searchOrders}>
                  <input
                    value={searchQuery}
                    data-testid="crcInput"
                    name="search"
                    type="text"
                    className={styles.inputField}
                    onChange={updateSearchQuery}
                    placeholder="Customer email or Reservation ID"
                    required
                  />
                  <button
                    className={styles.searchButton}
                    type="submit"
                    id="searchBtn"
                    data-testid="searchBtn"
                  >
                    <div className={styles.searchIcon} />
                  </button>
                </form>
              </div>
            </div>
            {Object.keys(reservations).length !== 0
              ? Object.keys(reservations).map(
                (commonDealerId, index) => {
                  return (
                    <CustomerReservationTable
                      {...props}
                      showOrderDetails={handleShowOrderDetails}
                      key={commonDealerId}
                      isNADealer={false}
                      index={index}
                      fromCrc={true}
                      commonDealerId={commonDealerId}
                      selectedMarket={selectedMarket}
                      totalNumberOfResults={
                        reservations[commonDealerId].length
                      }
                      reservations={reservations[commonDealerId]}
                    />
                  );
                }
              )
              : loaded && (
              <div
                id="noOrders"
                className={styles.noOrders}
                key="none-found"
              >
                There are no orders that match your search. Please try
                again.
              </div>
            )}
          </div>
        </section>
      </div>
    ) : (
      <OrderDetailsNewVersion
        {...props}
        fromCrc={true}
        selectedMarket={selectedMarket}
        lang={LANGUAGE_MARKET_MAP[selectedMarket.toUpperCase()]}
        showOrderDetails={handleShowOrderDetails}
        userDetails={props.userDetails}
        reservationId={orderId}
        commonId={commonId}
        localizedInfo={localizedInfo}
      />
    )
  ) : (
    ""
  );
}

export default withTranslation("emp")(OrdersSearch);
